<template>
    <BasePanel
        headline='lang_AZ_GROUPS_PANEL_CAPTION_FINANCE'
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>

            <!-- row for PAYMENT ORDER textarea -->
            <v-row class="pt-4">
                <v-col>
                    <v-textarea class="pl-1 pr-1"
                        v-model="getPaymentOrder"
                        rows="3"
                        :label="$t('lang_GENERAL_CAPTION_PAYMENT_ORDER')"
                        :alvqa="alvqa + '-payment-order'"
                        :disabled="false"
                        :clearable="false"
                        :readonly="true"
                    />
                </v-col>
            </v-row>

            <v-row>

                <!-- column 1: BANK data -->
                <v-col>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getAccountHolder"
                            :label="$t('lang_GENERIC_CAPTION_ACCOUNT_HOLDER')"
                            :alvqa="alvqa + '-account-holder'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getBankName"
                            :label="$t('lang_GENERAL_CAPTION_BANK_NAME')"
                            :alvqa="alvqa + '-bank-name'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getIban"
                            :label="$t('lang_GENERAL_CAPTION_IBAN_ACCOUNT_NO')"
                            :alvqa="alvqa + '-iban'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getBic"
                            :label="$t('lang_GENERAL_CAPTION_BIC_SWIFT_ABA')"
                            :alvqa="alvqa + '-bic'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getPaymentTarget"
                            :label="$t('lang_GENERIC_CAPTION_PAYMENT_TARGET')"
                            :alvqa="alvqa + '-payment-target'"
                        />
                    </v-row>
                </v-col>

                <!-- column 2: TAX data -->
                <v-col>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getVatId"
                            :label="$t('lang_GENERIC_CAPTION_VAT_ID')"
                            :alvqa="alvqa + '-vat-id'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getVatRetail"
                            :label="$t('lang_AZ_PERSONS_CAPTION_VAT_RETAIL')"
                            :alvqa="alvqa + '-vat-retail'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getVatLicense"
                            :label="$t('lang_AZ_PERSONS_CAPTION_VAT_LICENSE')"
                            :alvqa="alvqa + '-vat-license'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxOffice"
                            :label="$t('lang_GENERAL_CAPTION_TAX_OFFICE')"
                            :alvqa="alvqa + '-tax-office'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxNumber"
                            :label="$t('lang_GENERAL_CAPTION_TAX_NO')"
                            :alvqa="alvqa + '-tax-number'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxIdNumber"
                            :label="$t('lang_GENERAL_CAPTION_TAX_ID_GERMAN')"
                            :alvqa="alvqa + '-tax-id-number'"
                        />
                    </v-row>
                </v-col>

                <!-- column 3: COMPANY data -->
                <v-col>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getRegistrationNumber"
                            :label="$t('lang_GENERAL_CAPTION_COMPANY_REGISTRATION_NO')"
                            :alvqa="alvqa + '-registration-number'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getRegisterCourt"
                            :label="$t('lang_GENERAL_CAPTION_REGISTRATION_OFFICE')"
                            :alvqa="alvqa + '-register-court'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxWaiver"
                            :label="$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER')"
                            :alvqa="alvqa + '-dropdown-tax-waiver'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxWaiverFrom"
                            :label="$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER_FROM')"
                            :alvqa="alvqa + '-datepicker-tax-waiver-from'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getTaxWaiverTo"
                            :label="$t('lang_AZ_PERSONS_CAPTION_TAX_WAIVER_TO')"
                            :alvqa="alvqa + '-datepicker-tax-waiver-to'"
                        />
                    </v-row>
                </v-col>

            </v-row>

            <!-- PUBLISHING STATEMENTS text -->
            <v-row>
                <BaseReadOnlyTextField
                    :innerValue="getPublishingStatementsText"
                    :label="$t('lang_AZ_PERSONS_CAPTION_PUBLISHING_STATEMENTS_TEXT')"
                    :alvqa="alvqa + '-publishing-statements-text'"
                />
            </v-row>

            <!-- LABEL STATEMENTS text -->

            <v-row>
                <BaseReadOnlyTextField
                    :innerValue="getLabelStatementsText"
                    :label="$t('lang_AZ_PERSONS_CAPTION_LABEL_STATEMENTS_TEXT')"
                    :alvqa="alvqa + '-label-statements-text'"
                />
            </v-row>
            
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseReadOnlyTextField from '@/components/_readonly/BaseReadOnlyTextField'
import { DropdownAzTaxWaiver } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "AzDistributorsFinanceReadOnlyPanel",
    components: {
        BasePanel,
        BaseReadOnlyTextField
    },
    data() {
        return {
            alvqa: "az-distributors-readonly-panel-finance"
        }
    },
    computed: {
        getPaymentOrder()               { return this.$store.getters.getAzDistributorsFinanceDetailsPaymentOrder },
        getAccountHolder()              { return this.$store.getters.getAzDistributorsFinanceDetailsAccountHolder },
        getPaymentTarget()              { return this.$store.getters.getAzDistributorsFinanceDetailsPaymentTarget },
        getVatId()                      { return this.$store.getters.getAzDistributorsFinanceDetailsVatId },
        getIban()                       { return this.$store.getters.getAzDistributorsFinanceDetailsIban },
        getVatRetail() { 
            let value = this.$store.getters.getAzDistributorsFinanceDetailsVatRetail 
            return (value != null ? value.toString() : '') 
        },
        getVatLicense() { 
            let value = this.$store.getters.getAzDistributorsFinanceDetailsVatLicense 
            return (value != null ? value.toString() : '') 
        },
        getTaxOffice()                  { return this.$store.getters.getAzDistributorsFinanceDetailsTaxOffice },
        getBic()                        { return this.$store.getters.getAzDistributorsFinanceDetailsBic },
        getRegistrationNumber()         { return this.$store.getters.getAzDistributorsFinanceDetailsRegistrationNumber },
        getTaxNumber()                  { return this.$store.getters.getAzDistributorsFinanceDetailsTaxNumber },
        getBankName()                   { return this.$store.getters.getAzDistributorsFinanceDetailsBankName },
        getRegisterCourt()              { return this.$store.getters.getAzDistributorsFinanceDetailsRegisterCourt },
        getTaxIdNumber()                { return this.$store.getters.getAzDistributorsFinanceDetailsTaxIdNumber },
        getTaxWaiver()                  { return this.$store.getters.getAzDistributorsFinanceDetailsTaxWaiver },
        getTaxWaiverFrom()              { 
            let date = this.$store.getters.getAzDistributorsFinanceDetailsTaxWaiverFrom
            return date ? this.$d(new Date(date), 'alvDateFormat') : ''
        },
        getTaxWaiverTo()                { 
            let date = this.$store.getters.getAzDistributorsFinanceDetailsTaxWaiverTo
            return date ? this.$d(new Date(date), 'alvDateFormat') : ''
        },
        getPublishingStatementsText()   { return this.$store.getters.getAzDistributorsFinanceDetailsPublishingStatementsText },
        getLabelStatementsText()        { return this.$store.getters.getAzDistributorsFinanceDetailsLabelStatementsText },

        getTaxWaiver() { 
            let value = this.$store.getters.getAzDistributorsFinanceDetailsTaxWaiver 
            if (value == null || value == "0") value = 0 // to show new option "not required"
            if (value == "1") value = 1 // temp fix until Goran has fixed BE
            if(value == "2") value = 2
            let result = DropdownAzTaxWaiver.find(element => {
                return element.value === value
            })

            if(result !== null && result !== undefined) return this.$t(result.text)
            else return null
        },
    },
    created() {
        this.$store.commit('setLanguages')
    },
}
</script>